/**
 * Display labels for the user dashboard. Used as the source of truth for the
 * sidebar rows, menu links, and route module name (which drives the browser tab title) so
 * the same label does not have to be kept in sync by hand across those locations.
 */
export const USER_DASHBOARD_MODULES = {
  dashboard: "My Dashboard",
} as const
